import { useCallback } from 'react';
import {
  createFileRoute,
  Link,
  redirect,
  useRouter,
} from '@tanstack/react-router';
import { z } from 'zod';
import { Text } from 'react-aria-components';
import { useAuth } from 'src/utils/auth';

import CompleteCreatorProfile from 'src/components/auth/CompleteCreatorProfile';

import type { ClientToken } from 'src/types/client';

const CompleteCreatorPage = () => {
  const { email, code } = Route.useSearch();
  const router = useRouter();
  const auth = useAuth();

  const onCompleted = useCallback(
    async (data: ClientToken) => {
      auth.onLogin(data);
      await router.invalidate();
    },
    [auth, router]
  );

  return (
    <div>
      <CompleteCreatorProfile
        email={email}
        code={code}
        onCompleted={onCompleted}
      />
      <Text
        elementType="p"
        className="text-surface-alt-75 font-medium mt-4 text-center"
      >
        Already have an account?{' '}
        <Link
          to="/creator-login"
          className="text-surface-alt-ghost-75 font-semibold hover:underline"
        >
          Sign In
        </Link>
      </Text>
    </div>
  );
};

const CompleteCreatorSchema = z.object({
  email: z.string().email(),
  code: z.string().length(64),
});

export const Route = createFileRoute('/_auth/complete-creator')({
  validateSearch: (search) => CompleteCreatorSchema.parse(search),
  beforeLoad: async ({ search }) => {
    const { success } = CompleteCreatorSchema.safeParse(search);

    if (!success) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/creator-login',
        replace: true,
      });
    }
  },
  component: CompleteCreatorPage,
});
